import { SerializedPoolConfig } from './types'

export function serializePool(pool): SerializedPoolConfig {
  const earningToken = pool.earningToken.serialize
  const stakingToken = pool.stakingToken.serialize

  return {
    ...pool,
    earningToken,
    stakingToken,
  }
}
